<template>

  <div id="vy_body">
    <div id="vy_grid">
      <div id="vy_left_nav" class="p-4">
        <!--左サイドバー-->
          <component v-if="displayLeft"
                     v-bind:is="contentLeft"
                     v-bind:param="paramLeft"
                     v-on:call="call"/>
      </div>
      <div id="vy_main">
        <main>
          <div class="pc_only">  
            <h2 class="vy-kojin-title">{{ title }}</h2>

            <article style="padding: 0 10px;">

                <div id="manual_area">

                    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />設定画面のマニュアル</span>
                    <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

                </div>
                <br clear="all">

            <!--メインコンテンツ-->
            <hr>
                <table class="vy-form-table">
            
                    <!-- 社協名 -->
                    <tr >
                    <th>
                        <label for="shakyo_name">
                            事業者名
                        </label>
                    </th>
                    <td style="text-align: left;">
                        {{ shakyo_list.shakyo_name }}（{{ shakyo_list.choson_code }}）
                        </td>
                    </tr>
                    <tr >
                        <td colspan=2><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- ヘッダー -->

                    <tr >
                    <th>
                        <label for="header_logo">
                            事業のタイトルと事業者名

                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon" style="min-width:600px">
                                    PCの場合は「左側サイドバー」、スマートフォンの場合は「ヘッダー」に表示されます。<br>
                                    ※ ロゴは、正方形の画像をご用意ください。
                                    <div style="margin-left:17px">また、文字の長さによってはレイアウトが崩れる場合があります。</div>
                                </span>
                            </span>
                        </label>
                    </th>
                        <td style="">
                            
                            <!-- プレビュー -->
                            
                            <div style="
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            text-align: center;">
                                <img v-if="shakyo_list.header_logo" id="by-logo" v-bind:src="shakyo_list.header_logo" alt="ボラ活エール" style="width: 150px;height:150px" />
                                <img v-else id="by-logo" src="../../images/logo.png" alt="ボラ活エール"  />

                                <b :style="title_style1">{{ shakyo_list.header_title1 }}</b>
                                <b :style="title_style2">{{ shakyo_list.header_title2 }}</b>
                            </div>
                            <br>
                            
                            <div style="text-align: left;display: flex;align-items: center;margin:10px 0">
                        <div style="width:100px">ロゴ</div>
                            <input type='file' id="img_file" @change="imgUpload" accept="image/*" :disabled="shakyouser_flg"/>
                            </div>
                            <div style="text-align: left;display: flex;align-items: center;margin:10px 0">
                            
                        <div style="width:100px">事業のタイトル</div>
                            
                            <input type="text" class="form-control enter_forcus" id="header_title1" name="header_title1" 
                                v-model="shakyo_list.header_title1" v-on:change="checkEdit"  style="width:250px;margin-right:10px" :disabled="shakyouser_flg"/>
                            色：
                                <select @change="color_change1" class="form-select enter_forcus" :disabled="shakyouser_flg"
                                    name="header_title_color1" id="header_title_color1" v-model="shakyo_list.header_title_color1" style="width: auto;float: left;" >
                                    <option v-for:="i in color_list.length" v-bind:value="color_code_list[i-1]">{{ color_list[i-1]}}</option>
                                </select>   
                            </div>
                            <div style="text-align: left;display: flex;align-items: center;">
                                
                        <div style="width:100px">事業者名</div>
                            <input type="text" class="form-control enter_forcus" id="header_title2" name="header_title2" :disabled="shakyouser_flg"
                                v-model="shakyo_list.header_title2" v-on:change="checkEdit" style="width: 250px;margin-right:10px"/>
                            色：
                                <select @change="color_change2" class="form-select enter_forcus" :disabled="shakyouser_flg"
                                    name="header_title_color2" id="header_title_color2" v-model="shakyo_list.header_title_color2" style="width: auto;float: left;" >
                                    <option v-for:="i in color_list.length" v-bind:value="color_code_list[i-1]">{{ color_list[i-1]}}</option>
                                </select>   
                            </div>

                            
                        </td>

                    </tr>

                    <tr >
                        <td colspan=2><div class="vy-dotted"></div></td>
                    </tr>
                    
                    <!-- 公開日 -->
                    <tr >
                    <th>
                        <label for="kokai_date">公開日
                        
                        <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon">
                                    「体験プログラムの内容を公開する日」になります。<br><br>
                                    チラシや会報誌などが世の中に出回る時期など、体験ユーザーに公開される日を目安として設定してください。
                                </span>
                            </span>
                        </label>
                    </th>
                        <td style="text-align: left; display: flex;">
                            <input type="date" class="form-control enter_forcus" id="kokai_date" name="kokai_date" 
                            max="9999-12-31" 
                            v-model="shakyo_list.kokai_date"  v-on:change="checkEdit"  style="width: 150px;" :disabled="shakyouser_flg"/>

                            <input type="time" class="form-control enter_forcus" id="kokai_start" name="kokai_start" 
                                v-model="shakyo_list.kokai_start"  v-on:change="checkEdit"   style="width: 115px;" :disabled="shakyouser_flg"/>
                        </td>
                    </tr>
                    
                  <!-- 公開終了日 -->
                  <tr >
                  <th>
                      <label for="kokai_date">公開終了日
                      
                      <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                                「体験プログラムの公開を終了する日」になります。<br><br>
                                受付〆切日に関わらず、この日時を過ぎると誰も申し込めなくなります。
                            </span>
                        </span>
                    </label>
                  </th>
                      <td style="text-align: left; display: flex;">
                          <input type="date" class="form-control enter_forcus" id="kokai_date" name="kokai_end_date" 
                          max="9999-12-31" 
                          v-model="shakyo_list.kokai_end_date"  v-on:change="checkEdit"  style="width: 150px;" :disabled="shakyouser_flg"/>

                          <input type="time" class="form-control enter_forcus" id="kokai_start" name="kokai_end_time" 
                             v-model="shakyo_list.kokai_end_time"  v-on:change="checkEdit"   style="width: 115px;" :disabled="shakyouser_flg"/>
                      </td>
                  </tr>
                    <!-- 申込開始日 -->
                    <tr >
                        <th>
                            <label for="moshikomi_date">申込開始日
                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon">
                                    この日付より前に体験ユーザー側の画面にアクセスすると、体験プログラムの内容は表示されますが、お申込みはできません。<br><br>
                                    事業全体の「申込受付期間」が決まったら、その開始日を目安として設定してください。
                                </span>
                            </span>
                        </label>
                        </th>
                        <td style="text-align: left; display: flex;">
                        <input type="date" class="form-control enter_forcus" id="moshikomi_date" name="moshikomi_date" 
                        max="9999-12-31" 
                        v-model="shakyo_list.moshikomi_date"  v-on:change="checkEdit" style="width: 150px;" :disabled="shakyouser_flg"/>
                        <input type="time" class="form-control enter_forcus" id="moshikomi_start" name="moshikomi_start" 
                        v-model="shakyo_list.moshikomi_start"  v-on:change="checkEdit" style="width: 115px;" :disabled="shakyouser_flg"/>
                      </td>
                  </tr>
                  <!-- 受付終了日 -->
                    <tr >
                        <td colspan=2><div class="vy-dotted"></div></td>
                    </tr>

                    <tr>
                        <th rowspan=2>
                            <label for="end_date">受付終了日
                                <span class="balloon_parent">
                                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                                    <span class="balloon" style="width:600px">
                                        事業全体で、一括で申込みを締め切る場合は、<b><u>事業単位</u></b>を選んでください。<br>
                                        プログラムごとに申込み期限が変動する場合は、<b><u>プログラム単位</u></b>を選んでください。
                                    </span>
                                </span>
                            </label>
                        </th>
                        
                        <td style="text-align: left;">

                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="end_shubetsu1" name="end_shubetsu1" value=1 v-model="end_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="end_shubetsu1">事業単位</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="end_shubetsu2" name="end_shubetsu2" value=2 v-model="end_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="end_shubetsu2">プログラム単位</label>
                            </div>
                        </td>
                    
                    </tr>

                    <tr>
                        
                        <td style="text-align: left;">
                            <div style=" display: flex;">
                                <input type="date" class="form-control enter_forcus" id="end_date" name="end_date"   v-on:change="checkEdit" 
                                max="9999-12-31" 
                                v-model="shakyo_list.end_date" style="width: 150px;" :disabled="shakyouser_flg"/>

                                <input type="time" class="form-control enter_forcus" id="end_time" name="end_time"   v-on:change="checkEdit" 
                                v-model="shakyo_list.end_time"  style="width: 115px;" :disabled="shakyouser_flg"/>
                            </div>
                        </td>
                    </tr>

                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  
                  <!-- 公開前メッセージ -->
                  <tr >
                  <th>
                      <label for="policy">公開前メッセージ
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                               公開日より前に表示されるメッセージを入力することができます。
                            </span>
                        </span></label>
                  </th>
                  <td style="text-align: left;" colspan="2">
                    <!--
                        <textarea style="width:100%;height:200px;" v-model="shakyo_list.before_message" class="form-control"></textarea>
                        -->
                    <div  :style="{ pointerEvents: shakyouser_flg ? 'none' : 'auto', opacity: shakyouser_flg ? 0.6 : 1 }">
                        <QuillEditor class="form-control" style="width:100%;height:200px;"
                            v-model:content="shakyo_list.before_message"
                            @textChange="checkEdit" 
                            @ready="onReady"
                            contentType="html"
                            theme="snow"
                            :toolbar="toolbar"
                        />
                    </div>
                  </td>
                  </tr>
                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  
                  <!-- 公開終了メッセージ -->
                  <tr >
                  <th>
                      <label for="policy">公開終了メッセージ
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                               公開終了日より後に表示されるメッセージを入力することができます。
                            </span>
                        </span></label>
                  </th>
                  <td style="text-align: left;" colspan="2">
                    <!--
                        <textarea style="width:100%;height:200px;" v-model="shakyo_list.after_message" class="form-control"></textarea>
                        -->
                    <div  :style="{ pointerEvents: shakyouser_flg ? 'none' : 'auto', opacity: shakyouser_flg ? 0.6 : 1 }">
                        <QuillEditor class="form-control" style="width:100%;height:200px;"
                            v-model:content="shakyo_list.after_message"
                            @textChange="checkEdit" 
                            @ready="onReady"
                            contentType="html"
                            theme="snow"
                            :toolbar="toolbar"
                        />
                    </div>
                </td>
                  </tr>
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- アカウント登録時メッセージ -->
                  <tr >
                  <th>
                      <label for="policy">アカウント登録時メッセージ
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                               アカウント登録時の注意事項等を入力できます。
                            </span>
                        </span></label>
                  </th>
                  <td style="text-align: left;" colspan="2">
<!--
                    <textarea style="width:100%;height:200px;" v-model="shakyo_list.account_message" class="form-control"></textarea>
-->
                    <div  :style="{ pointerEvents: shakyouser_flg ? 'none' : 'auto', opacity: shakyouser_flg ? 0.6 : 1 }">
                        <QuillEditor class="form-control" style="width:100%;height:200px;"
                            v-model:content="shakyo_list.account_message"
                            @textChange="checkEdit" 
                            @ready="onReady"
                            contentType="html"
                            theme="snow"
                            :toolbar="toolbar"
                        />
                    </div>
                  </td>
                  </tr>
                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- ユーザー登録時メッセージ -->
                  <tr >
                  <th>
                      <label for="policy">ユーザー登録時メッセージ
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                               ユーザー登録時の注意事項等を入力できます。
                            </span>
                        </span></label>
                  </th>
                  <td style="text-align: left;" colspan="2">
                        <!--
                        <textarea style="width:100%;height:200px;" v-model="shakyo_list.user_add_message" class="form-control"></textarea>
                        -->
                    <div  :style="{ pointerEvents: shakyouser_flg ? 'none' : 'auto', opacity: shakyouser_flg ? 0.6 : 1 }">
                        <QuillEditor class="form-control" style="width:100%;height:200px;"
                            v-model:content="shakyo_list.user_add_message"
                            @textChange="checkEdit" 
                            @ready="onReady"
                            contentType="html"
                            theme="snow"
                            :toolbar="toolbar"
                        />
                    </div>
                    </td>
                  </tr>

                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- 事業者二次元コード対応 -->
                  <tr>
                    <th>
                        <label for="moshikomi_date">事業者二次元コード
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:750px">
                               二次元コードを利用する際、【表示する】か又は【読み取る】を選択する。<br>
                               ※【表示する】場合、事業者は二次元コードを表示、体験ユーザー側で二次元コードを読取りチェックインします。<br>&nbsp;&nbsp;
                                 【読み取る】場合、体験ユーザー側で二次元コードを表示、事業者で二次元コードを読取りチェックインします。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="checkin_disp_flg1" name="checkin_disp_flg1" value=1 v-model="shakyo_list.checkin_disp_flg"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="checkin_disp_flg1">表示する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="checkin_disp_flg2" name="checkin_disp_flg2" value=2 v-model="shakyo_list.checkin_disp_flg"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="checkin_disp_flg2">読み取る</label>
                    </div>
                    </td>
                
                </tr>
                  
                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  
                    <!-- 学生以外の参加 -->

                    <tr>
                        <th>
                            <label for="sanka">学生以外の参加
                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon" style="width:650px">
                                    ● 有の場合：体験ユーザーの「体験者区分」で「学生」「一般」を選択できるようになります。<br>
                                    ● 無の場合：体験ユーザーの「体験者区分」が「学生」で固定になります。
                                </span>
                            </span></label>
                        </th>
                        <td>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="sanka1" name="sanka1" value=1 v-model="shakyo_list.sanka"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                            <label class="form-check-label" for="sanka1">有</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="sanka2" name="sanka2" value=2 v-model="shakyo_list.sanka"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                            <label class="form-check-label" for="sanka2">無</label>
                        </div>
                        </td>
                    
                    </tr>
                    <tr >
                        <td colspan=2><div class="vy-dotted"></div></td>
                    </tr>
                   <!-- 事前説明会の実施 -->
                  <tr>
                    <th>
                        <label for="flow">事前説明会の実施</label>
                    </th>
                    <td colspan=2>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="jizen_jisshi1" name="jizen_jisshi1" value=1 v-model="shakyo_list.jizen_jisshi"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="jizen_jisshi1">実施する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="jizen_jisshi2" name="jizen_jisshi2" value=2 v-model="shakyo_list.jizen_jisshi"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="jizen_jisshi2">実施しない</label>
                    </div>
                    </td>
                
                </tr>
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- 事後集会の実施 -->
                  <tr>
                    <th>
                        <label for="flow">事後集会の実施
                       </label>
                    </th>
                    <td colspan=2>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="jigo_jisshi1" name="jigo_jisshi1" value=1 v-model="shakyo_list.jigo_jisshi"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="jigo_jisshi1">実施する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="jigo_jisshi2" name="jigo_jisshi2" value=2 v-model="shakyo_list.jigo_jisshi"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="jigo_jisshi2">実施しない</label>
                    </div>
                    </td>
                
                </tr>

                    <tr >
                        <td colspan=2><div class="vy-dotted"></div></td>
                    </tr>
                    <template v-if="shakyo_list.jizen_jisshi == 1">
                        <!-- 体験申込の流れ（事前説明会の実施が1（実施する）なら表示） -->
                        <tr>
                            <th>
                                <label for="flow">体験申込の流れ
                                <span class="balloon_parent">
                                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                                    <span class="balloon" style="width:800px">
                                        ● ケース１：事前説明会へ参加していることを確認できたら、体験プログラムを申込めるようになります。
                                        <div style="color:red;padding-left:10px;">参加が確認できるまで、体験プログラムの申込みはできません。</div>
                                        <div style="padding-left:10px;padding-bottom:10px;">また、「ホーム画面の初期表示変更日時」を過ぎるまで、体験者側のホーム画面は事前説明会一覧になります。</div>
                                        ● ケース２：事前説明会と体験プログラムを同時に申込みます（事前説明会参加の確認は行いません）。
                                        <div style="padding-left:10px">※ 事前説明会を実施しない場合も、こちらを選択してください。</div>
                                    </span>
                                </span></label>
                            </th>
                            <td colspan=2>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="flow1" name="flow1" value=1 v-model="taiken_flow"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="flow1">ケース１</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="flow2" name="flow2" value=2 v-model="taiken_flow"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="flow2">ケース２</label>
                            </div>
                            <!--
                            <br>
                            ケース１：事前説明会申込 → 体験申込（事前説明会参加確認後）<br>
                            ケース２：体験申込（事前説明会同時申込） ※事前説明会を実施しない場合も、こちらを選択してください。
                            -->
                            <template v-if="taiken_flow == 1">
                                <!--ケース1の場合のみ表示-->
                                <div style=" display: flex;align-items: center;">
                                    <b>ホーム画面の初期表示変更日時</b><input type="date" class="form-control enter_forcus" id="flow_end_date" name="flow_end_date" 
                                    max="9999-12-31" 
                                    v-model="shakyo_list.flow_end_date"  v-on:change="checkEdit" :disabled="shakyouser_flg"  style="width: 150px;margin-left:10px"/>

                                    <input type="time" class="form-control enter_forcus" id="flow_end_time" name="flow_end_time" 
                                        v-model="shakyo_list.flow_end_time"  v-on:change="checkEdit"   :disabled="shakyouser_flg" style="width: 115px;"/>
                                </div>
                            </template>
                            </td>
                        
                        </tr>
                        
                        <tr >
                            <td colspan=2><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    <!-- 自動送信メールの実施 -->

                    <tr>
                        <th>
                            <label for="mail_shubetsu">自動送信メールの実施
                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon" style="width:550px">
                                    変更すると「メール情報」の自動送信メールの実施がこちらの設定に統一されます。<br>
                                ※ 後から個別に変更することも可能です。
                                </span>
                            </span></label>
                        </th>
                        <td colspan=2>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="mail_shubetsu1" name="mail_shubetsu1" value=1 v-model="mail_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="mail_shubetsu1">する</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="mail_shubetsu2" name="mail_shubetsu2" value=2 v-model="mail_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="mail_shubets2">しない</label>
                            </div>
                            <br>
                            <!--
                            <span style="color:red">
                                変更すると「メール情報」の自動送信メールの実施がこちらの設定に統一されます。<br>
                                ※ 後から個別に変更することも可能です。
                            </span>-->
                        </td>
                    
                    </tr>
                   
                    
                    <tr >
                        <td colspan=2><div class="vy-dotted"></div></td>
                    </tr>

                    <!--ユーザー登録後アンケートの実施-->
                  <tr>
                    <th>
                        <label for="enqete_shubetsu">ユーザー登録後アンケートの実施
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:600px">
                                ● 実施する場合：プロフィール登録後に、アンケートを取ることができます。<br>
                                <div style="color:red;padding-left:10px;padding-bottom:10px;">体験ユーザーは、アンケートに回答していただくまで、体験プログラムのお申込みが出来ません。</div>
                                ● 実施しない場合：プロフィール登録後、アンケートの画面に移動せず、すぐお申込みいただけるようになります。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="enqete_shubetsu1" name="enqete_shubetsu1" value=1 v-model="enqete_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="enqete_shubetsu1">する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="enqete_shubetsu2" name="enqete_shubetsu2" value=2 v-model="enqete_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="enqete_shubetsu2">しない</label>
                    </div>
                    </td>
                
                </tr>
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- チェックイン機能の利用 -->
                  <tr>
                    <th>
                        <label for="moshikomi_date">チェックイン機能の利用
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:750px">
                               二次元コードを利用したチェックイン機能を利用するかどうかの設定です。<br>
                               ※利用しない場合、体験プログラムの参加記録などは事業者様で全てチェックしていただく必要がございます。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="checkin_flg1" name="checkin_flg1" value=1 v-model="shakyo_list.checkin_flg"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="checkin_flg1">利用する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="checkin_flg2" name="checkin_flg2" value=2 v-model="shakyo_list.checkin_flg"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="checkin_flg2">利用しない</label>
                    </div>
                    </td>
                
                </tr>

                 <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                    <!-- 活動報告書の提出 -->
                    <tr>
                        <th>
                            <label for="moshikomi_date">活動報告書の提出（システム利用）
                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon" style="width:600px">
                                    報告書の提出・集計を別の方法で行う場合は、こちらを「不要」に設定してください。<br>
                                    ※ 必要・不要にかかわらず、参加証明書の発行には報告書の提出が必要です。
                                </span>
                            </span></label>
                        </th>
                        <td>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="houkoku_radio1" name="houkoku_radio1" value=1 v-model="shakyo_list.houkoku_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                            <label class="form-check-label" for="houkoku_radio1">必要</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="houkoku_radio2" name="houkoku_radio2" value=2 v-model="shakyo_list.houkoku_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                            <label class="form-check-label" for="houkoku_radio2">不要</label>
                        </div>
                        </td>
                    
                    </tr>
                    
                    <template v-if="shakyo_list.houkoku_shubetsu == 1">
                        <!-- 活動報告書の提出が「必要」な場合のみ表示-->
                        <tr >
                            <td colspan=2><div class="vy-dotted"></div></td>
                        </tr>

                        <!-- 活動報告書の確認 -->
                        <tr>
                            <th>
                                <label for="moshikomi_date">活動報告書の確認（工程遷移の一時中断）
                                <span class="balloon_parent">
                                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                                    <span class="balloon" style="width:550px">
                                        報告書が提出されたら、管理者が確認するかどうかを設定します。<br>
                                        「必要」に設定した場合、確認が完了するまで参加証明書を発行できません。
                                    </span>
                                </span></label>
                            </th>
                            <td>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="kakunin_radio1" name="kakunin_radio1" value=1 v-model="shakyo_list.houkoku_kainyu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="kakunin_radio1">必要</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="kakunin_radio2" name="kakunin_radio2" value=2 v-model="shakyo_list.houkoku_kainyu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                                <label class="form-check-label" for="kakunin_radio2">不要</label>
                            </div>
                            </td>
                        
                        </tr>
                    </template>
                    

                    <tr >
                        <td colspan=2><div class="vy-dotted"></div></td>
                    </tr>
                    
                    <!-- 参加証明書のダウンロード -->
                    <tr>
                        <th>
                            <label for="moshikomi_date">参加証明書のダウンロード
                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon" style="width:650px">
                                参加証明書を、システムを利用せず別の手段で送付したり、証明書自体を用意しない場合は「不要」を設定してください。
                                </span>
                            </span></label>
                        </th>
                        <td>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="shomei_radio1" name="shomei_radio1" value=1 v-model="shakyo_list.shomeisho_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                            <label class="form-check-label" for="shomei_radio1">必要</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="shomei_radio2" name="shomei_radio2" value=2 v-model="shakyo_list.shomeisho_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                            <label class="form-check-label" for="shomei_radio2">不要</label>
                        </div>
                        </td>
                    
                    </tr>

                    <!-- 参加証明書のダウンロード回数（参加証明書の発行が「必要」の場合のみ表示） -->
                    <tr v-show="shakyo_list.shomeisho_shubetsu == 1">
                        <th>
                            <label for="shomeisho_count">ダウンロード回数
                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon" style="width:700px">
                                    体験ユーザーは、設定した回数まで証明書をダウンロードできます（参加したプログラム毎の回数です）。
                                </span>
                            </span></label>
                        </th>
                        <td  colspan=2>
                            <div style="text-align: left;display: flex;align-items: center;">
                            <input type="number" style="width:80px;margin-right:10px" class="form-control" id="shomeisho_count" name="shomeisho_count" 
                              v-on:change="checkEdit" 
                            v-model="shakyo_list.shomeisho_count" min=1 :disabled="shakyouser_flg" /> 回 
                            <!--
                            <span style="color:red;padding-left:10px">
                                申込者は設定した回数まで証明書をダウンロードできます（参加したプログラム毎の回数です）。</span>-->
                            </div>
                        </td>
                    </tr>
                   
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  
                 

                  <!-- 総申込者数利用の指定 -->
                  <tr>
                    <th>
                        <label for="moshikomi_date">総申込者数利用の指定
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:750px">
                                指定する場合、体験プログラム側の定員に空きがあっても、この総申込者数を超える申し込みはできなくなります。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="all_moshikomi_flg1" name="all_moshikomi_flg1" value=1 v-model="shakyo_list.all_moshikomi_flg"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="all_moshikomi_flg1">指定する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="all_moshikomi_flg2" name="all_moshikomi_flg2" value=2 v-model="shakyo_list.all_moshikomi_flg"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="all_moshikomi_flg2">指定しない</label>
                    </div>
                    </td>
                
                </tr>

                <template v-if="shakyo_list.all_moshikomi_flg == 1">
                    <tr >
                        <th>
                            <label for="cancel_count">総申込者数</label>
                        </th>
                        <td  colspan=2>
                            
                       <div style="text-align: left;display: flex;align-items: center;">事業全体で
                          <input type="number" style="width:100px;margin:0 10px" class="form-control" id="all_moshikomi_count" name="all_moshikomi_count" 
                            v-on:change="checkEdit" 
                          v-model="shakyo_list.all_moshikomi_count" min=1  :disabled="shakyouser_flg" /> 人まで申込可能
                          </div>
                        </td>
                    
                    </tr>
                </template>
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>

                  <!-- 体験義務日数 -->
                  <tr>
                    <th>
                        <label for="taiken_nissu">体験義務日数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:550px">
                                設定した日数以上の体験プログラム参加で、参加証明書の発行が可能となります。
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="taiken_nissu" name="taiken_nissu" 
                            v-on:change="checkEdit" 
                          v-model="shakyo_list.taiken_nissu" min=1 :disabled="shakyouser_flg" /> 日以上
                          <!--
                          <span style="color:red;padding-left:10px">
                            設定した日数以上の体験参加で証明書の発行が可能となります。</span>
                            -->
                          </div>
                      </td>
                
                </tr>
                
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- プログラム申込可能回数の実施 -->
                  <tr>
                    <th>
                        <label for="moshikomi_date">体験プログラム申込可能回数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:750px">
                                体験ユーザーは、設定した数までプログラムを申込むことができます（キャンセルしたプログラムを除く）。<br>
                                一人当たりの申込数を制限したい場合や、イタズラ防止にご利用ください。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="program_shubetsu1" name="program_shubetsu1" value=1 v-model="shakyo_list.program_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="program_shubetsu1">利用する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="program_shubetsu2" name="program_shubetsu2" value=2 v-model="shakyo_list.program_shubetsu"  v-on:change="checkEdit" :disabled="shakyouser_flg" />
                        <label class="form-check-label" for="program_shubetsu2">利用しない</label>
                    </div>
                    </td>
                
                </tr>

                  <!-- プログラム申込可能回数 -->
                  <tr v-show="shakyo_list.program_shubetsu == 1">
                    <th>
                        <label for="program_count">申込み可能回数上限</label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="shomeisho_count" name="program_count" 
                            v-on:change="checkEdit" 
                          v-model="shakyo_list.program_count" min=1 :disabled="shakyouser_flg" /> 回
                          <!--
                          <span style="color:red;padding-left:10px">
                            申込者は設定した数までプログラムを申込むことができます（キャンセルしたプログラムを除く）。</span>-->
                          </div>
                      </td>
                </tr>
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- キャンセル可能回数 -->
                  <tr>
                    <th>
                        <label for="cancel_count">申込キャンセル可能回数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:700px">
                                体験ユーザーは「マイページ」からプログラムをキャンセルすることができますが、その上限を設けることができます。<br>
                                ※「0」回に設定するとキャンセルできなくなります。
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="cancel_count" name="cancel_count" 
                            v-on:change="checkEdit" 
                          v-model="shakyo_list.cancel_count" min=0 max=99 :disabled="shakyouser_flg"/> 回
                          </div>
                      </td>
                
                </tr>
                <template v-if="shakyo_list.cancel_count != 0">
                  <!-- キャンセル可能日数 -->
                  <tr>
                    <th>
                        <label for="cancel_count">申込キャンセル可能日数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:700px">
                                体験ユーザーは申し込んだ体験プログラムの「参加日の初日の〇日前」までプログラムをキャンセルすることが可能になります。
                                ※ 申込キャンセル可能回数が「0」回（キャンセル不可）の場合は除く
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">参加日の初日の
                          <input type="number" style="width:80px;margin:0 10px" class="form-control" id="cancel_day" name="cancel_day" 
                            v-on:change="checkEdit" 
                          v-model="shakyo_list.cancel_day" min=1 :disabled="shakyouser_flg"  /> 日前までキャンセル可能
                          </div>
                      </td>
                
                    </tr>
                    <!-- キャンセル待ち機能 -->
                    <tr >
                        <th>
                            <label for="cancel_count">キャンセル待ち機能</label>
                        </th>
                        <td  colspan=2>
                            ※キャンセル待ち機能は準備中です。
                            <!--
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="cancel_setting1" name="cancel_setting1" value=0 v-model="shakyo_list.cancel_setting"  v-on:change="checkEdit" />
                            <label class="form-check-label" for="cancel_setting1">利用する</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="cancel_setting2" name="cancel_setting2" value=1 v-model="shakyo_list.cancel_setting"  v-on:change="checkEdit" />
                            <label class="form-check-label" for="cancel_setting2">利用しない</label>
                        </div>
                        -->

                        </td>
                    
                    </tr>
                    </template>
                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                    <tr >
                    <th>
                        <label for="policy">学生区分設定
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                                体験プログラムの参加条件と体験ユーザーの学生区分を設定します。<br>
                                利用しない区分は「×」にしてください。
                            </span>
                        </span>
                        </label>
                    </th>
                    
                    <td style="text-align: left;" colspan="2">
                        <table border=1 rules=all id="gakusei_kbn_table">
                            <!--
                            let gakusei_kbn_list = ref([1,1,1,1,1,1,1]) // 学生区分の利用可不可
                            let gakusei_meisho_list = ref(["小学生","中学生","高校生","高専生","専門学校生","大学生","大学院生"]) // 学生区分の名称
                            -->
                            <tr>
                                <td ><b>学生区分名称</b></td>
                                <td ><b>利用</b></td>
                            </tr>
                            <template v-for="(result,i) in gakusei_kbn_list" v-bind:key="i">
                                <tr>
                                    <td><input type="text"  v-model="gakusei_meisho_list[i]"  v-on:change="checkEdit" :disabled="shakyouser_flg" /></td>
                                    <td><input type="button"  v-bind:value="gakusei_kbn_list[i]=== '0' ? '×' : '〇'" v-on:click="gakusei_kbn_change(i)" style="width: 29px;" :disabled="shakyouser_flg"/></td>
                                </tr>
                            </template>

                        </table>

                    </td>
                  </tr>
                  
                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>

                  
                  <!-- 保護者同意義務年齢 -->
                  <tr>
                    <th>
                        <label for="taiken_nissu">保護者同意義務年齢
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:550px">
                               体験ユーザーは、この年齢を下回る場合、ユーザー登録時に保護者の同意が必要になります。
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="pc_age" name="pc_age" 
                            v-on:change="checkEdit" 
                          v-model="shakyo_list.pc_age" min=1 :disabled="shakyouser_flg" /> 歳未満
                          </div>
                      </td>
                
                </tr>
                
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- ユーザー情報設定 -->
                  <tr>
                    <th>
                        <label for="user_setting">ユーザー情報設定
                            <span class="balloon_parent">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon" style="width:550px">
                                体験ユーザーの項目表示や一般区分等の設定画面に移動します。<br>
                                ※ 設定画面の他の項目を編集していた場合、移動する前に保存してください。
                                </span>
                            </span>
                        </label>
                    </th>
                    <td  colspan=2>
                        <input type="button" value="移動する" v-on:click="user_setting_move" :disabled="shakyouser_flg" />
                    </td>
                
                </tr>
                
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- 一般区分の選択肢 -->
                <!--
                  <tr>
                    <th>
                        <label for="taiken_nissu">一般区分の選択肢
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:700px">
                               体験ユーザー登録時に体験者区分を「一般」に設定したとき、こちらの選択肢を選択できるようになります。<br>
                               選択肢は「、」で区切るように入力してください。<br>例：主婦、主夫、その他…
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="text" style="width:100%;margin-right:10px" class="form-control" id="ippan_select" name="ippan_select" 
                          v-model="shakyo_list.ippan_select" />
                          </div>
                      </td>
                
                </tr>
                
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  -->

                 
                <!-- プライバシーポリシーの登録 -->
                <tr >
                  <th>
                      <label for="policy">プライバシーポリシーの登録
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                                各社協様のホームページに掲載されている内容をそのままご入力ください。
                            </span>
                        </span></label>
                  </th>
                  <td style="text-align: left;" colspan="2">
                            <b>タイトル</b>
                            <input type="text" class="form-control" id="policy_title" name="policy_title" v-on:change="checkEdit" 
                                 v-model="shakyo_list.policy_title"  style="width:100%;" :disabled="shakyouser_flg"/>
                                 <br>
                        <b>本文</b>
                        <textarea style="width:100%;height:350px;" v-model="shakyo_list.policy" class="form-control"  v-on:change="checkEdit" :disabled="shakyouser_flg" ></textarea>
                        <br>
                        <b>フッター</b>
                        <textarea style="width:100%;height: 80px;text-align: right;" v-model="shakyo_list.policy_footer" class="form-control"  v-on:change="checkEdit" :disabled="shakyouser_flg" ></textarea>

                        </td>
                    </tr>
                    

                </table>

   <!-- 
                <button v-on:click="Update_check()"  class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" >保存</button>
-->
            </article>
          </div>

          <!--  スマホの体験プログラム一覧を表示する    -->
          <div class="sp_only">
            <component
                        v-bind:is="content"
                        v-bind:param="param"
                        v-on:call="call"
                        v-bind:key="render"
                        ref="comp">{{ title }}</component>
          </div>

          <!--フッター-->
          <FooterArea v-on:call="call"/>

        </main>

        <!--社協側のスマホ画面(2次元コードの表示や読取のため) -->
      </div>
      <div id="vy_right_nav" class="p-4">
          <!--右サイドバー-->
          <ShakyoRightBar  v-on:call="call"/>
      </div>
    </div>
  </div>
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
            v-bind:message_text="message"
            v-bind:message_cat="message_cat"
            v-bind:message_flag="message_flag"
            @close_message="Close_message"
            @ok_message="OK_message"/>

  <!-- ローディングアイコンを表示するモーダルウィンドウ -->
  <LoadingModal v-if="loading_flg"/>

</template>

<script setup>
/* eslint-disable */
  import ShakyoLeftbar from './ShakyoHomeLeftBar.vue'

  import ShakyoSmartMenu from './Smart/ShakyoSmartMenu.vue'
  import UserSearchSmart from './Smart/UserSearchSmart.vue'
  import ShakyoMyCode from './Smart/ShakyoMyCode.vue'
  import UserCheckin from './Smart/UserCheckin.vue'

  import ShakyoRightBar from './ShakyoRightBar.vue'
  import FooterArea from '../common/FooterArea.vue'
  import MessageModal from './ShakyoMessageModal.vue'

    /* ローディングアイコンを表示するモーダルウィンドウ */
    import LoadingModal from '../common/LoadingModal.vue'

  import { QuillEditor } from '@vueup/vue-quill'      // 
  import '@vueup/vue-quill/dist/vue-quill.snow.css'
  import Quill from 'quill'

  const toolbar = [
    ['bold', 'italic', 'underline', 'strike'],          // 文字装飾
    [{ color: [] }, { background: [] }],                // 色・背景
    [{ size: ['small', false, 'large', 'huge'] }],      // サイズ（小/標準/大/特大）
    [{ list: 'bullet' }],                               // 箇条書き
    ['link'],                                           // ハイパーリンク
    ['clean']                                           // 書式クリア
  ]

  // ハイパーリンク拡張(メールの場合mailtoを付加する)
  const Link = Quill.import('formats/link')

  class CustomLink extends Link {
    static sanitize(url) {

      if (/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(url)) {
      return "mailto:" + url
      }

      return super.sanitize(url)
    }
  }

  // 登録
  Quill.register(CustomLink, true)

  import { GlobalData, login_check,logout,getUser_email, Kaisai_setting } from '../js/userdata_shakyo.js'
  import { DateTimeSetting } from '../js/userdata.js'
  import { useRouter, useRoute } from 'vue-router'
  import { ref,shallowRef, watch, nextTick, onMounted, onUnmounted  } from 'vue'
  import axios from 'axios'
  const url = GlobalData.$API_URL
  const content = shallowRef('')
  const router = useRouter();
  const route = useRoute();
  login_check()
  let shakyo_list = ref({}) // 社協データ
  let mail_shubetsu = ref(1) // 自動送信メールの種別（変更があった場合は一括更新となるので別個に用意）
  let taiken_flow = ref(2) // 体験フローのパターン（変更があった場合は事前説明会申込メールの実施状況変更となるので別個に用意）
  let enqete_shubetsu = ref(1) // ユーザー登録後アンケートのパターン（変更があった場合はアンケート提出メールの実施状況変更となるので別個に用意）
  let end_shubetsu = ref(1) // 受付〆切種別　１：事業単位、２：プログラム単位（事業→プログラム単位への変更があった場合は〆切日を体験プログラムに適用する）

  let gakusei_kbn_list = ref() // 学生区分の利用可不可
  let gakusei_meisho_list = ref() // 学生区分の名称

  let color_list = ["黒","赤","青","水色","緑"];
  let color_code_list = ["black","red","blue","rgb(0,102,255)","green"];
  
    let title_style1 = ref({"color":"black","font-size": "14px","margin":"15px 0 0"})
    let title_style2 = ref({"color":"black","font-size": "17px"})


    let contentLeft = ref()// 表示する子コンポーネントの情報（左バー）
    // 左サイドバーに編集フラグを送る。左サイドバー側ではフラグによって保存ボタンの色を変える（edit_update = 0：未編集、1：編集、2：画面描画中につきボタンに影響させない）
    let paramLeft = {"edit_update":2}  
    let displayLeft = ref(true)

   // チェックイン機能の利用フラグ
   let checkin_flg = 2  

// 政令指定都市オプション機能　利用者使用フラグ　true:利用者使用 false:管理者使用
  let shakyouser_flg = ref(false)
  let shakyouser_date = []

let Shakyouser_error_count = 0
function Shakyouser_read(){
    if(GlobalData.$User_email == null) return
    if(GlobalData.kengen == 'kanri' || GlobalData.kengen == 'Kanri' || GlobalData.kengen == 'master' || GlobalData.kengen == 'Master') return
    //---------------- 社協英名から市区町村コードを取得
    axios.post(GlobalData.$API_URL+"Shakyouser_read", 
        {shakyouser_email:GlobalData.$User_email}
        ).then(response => {

        let rt = response["data"] 

        if(rt["status"] != 0){  // 異常終了時の処理
            alert("利用者情報の読み込み時にエラーが発生しました。")
            return
        }
            
        shakyouser_date = rt["shakyouser_info"]

        if(shakyouser_date.shakyouser_id){
            shakyouser_flg.value = true
            // 最終ログイン時間を設定します。
            Shakyouser_logincheck(shakyouser_date.shakyouser_id)
        }

    }).catch(error => {
        if(Shakyouser_error_count > 5){
            alert("利用者情報の読み込み時にエラーが発生しました。\n"+error)
        }else{
            Shakyouser_error_count++
            Shakyouser_read()
        }
        
    })
}

// 最終ログイン時間を設定します。
let Shakyouser_logincheck_error_count = 0
function Shakyouser_logincheck(shakyouser_id){
  const now = new Date()
  const japannow = new Date().getFullYear() + '-' +
                       String(now.getMonth() + 1).padStart(2, '0') + '-' +
                       String(now.getDate()).padStart(2, '0') + 'T' +
                       String(now.getHours()).padStart(2, '0') + ':' +
                       String(now.getMinutes()).padStart(2, '0') + ':' +
                       String(now.getSeconds()).padStart(2, '0')

  let send_array = {"shakyouser_id": shakyouser_id,
                    "last_login_time":japannow}

    // APIへ値を送信する
  axios.post(GlobalData.$API_URL+"Shakyouser_update",
    send_array,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data["status"] == 1){  // 異常終了時の処理
            alert("利用者情報の登録時にエラーが発生しました。")
        }
    })
    .catch(error => {
        if(Shakyouser_logincheck_error_count == 6){
            alert("利用者情報の読み込み時にエラーが発生しました。\n"+error)
        }else{
            Shakyouser_logincheck_error_count++
            setTimeout(function(){
                Shakyouser_logincheck(shakyouser_id)
            },"1000")
        }
	})
}
  GlobalData.shakyo = route.params.shakyo

let shakyo_error_count = 0
  function Shakyo_read(){
    //---------------- 社協英名から市区町村コードを取得
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
            {shakyo:GlobalData.shakyo}
            ).then(response => {

            GlobalData.choson_code = response["data"].choson_code
            shakyo_list.value = response["data"]
            console.log(shakyo_list.value.end_date)
            console.log(shakyo_list.value.end_time)


                // 自動送信メールの種別（変更があった場合は一括更新となるので別個に用意）
                mail_shubetsu.value = shakyo_list.value.mail_shubetsu

                // 体験フローのケース（変更があった場合は事前説明会申込メールの実施状況変更となるので別個に用意）
                taiken_flow.value = shakyo_list.value.flow

                // ユーザー登録後アンケートのパターン（変更があった場合はアンケート提出メールの実施状況変更となるので別個に用意）
                enqete_shubetsu.value = shakyo_list.value.enqete_shubetsu

                // 受付〆切種別　１：事業単位、２：プログラム単位（事業→プログラム単位への変更があった場合は〆切日を体験プログラムに適用する）
                end_shubetsu.value = shakyo_list.value.end_shubetsu

                // チェックイン機能の利用  1:利用する、2：利用しない  スマホ画面の時に使用
                checkin_flg = shakyo_list.value.checkin_flg

                // 学生区分の利用可不可と名称
                console.log(shakyo_list.value.gakusei_kbn_list)
                console.log(shakyo_list.value.gakusei_meisho_list)
                gakusei_kbn_list.value = shakyo_list.value.gakusei_kbn_list.split(",")
                gakusei_meisho_list.value = shakyo_list.value.gakusei_meisho_list.split(",")

            // プレビュー部分の色変え
            color_change1()
            color_change2()
            
        }).catch(error => {
        if(shakyo_error_count > 5){
            alert(error)
        }else{
            shakyo_error_count++
            Shakyo_read()
        }
        
    })
  }
Shakyo_read()

  const displayStatus = ref(true) //子コンポーネントを再レンダリングさせるためのフラグ
  let param = {}
  let title = "設定"

  /* メッセージを表示するモーダルウィンドウ */
  let message = ref("")//表示するメッセージ
  let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
  let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
  let message_flag = ref(false)//表示・非表示フラグ

  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント

  let Update_check = function(){
    
    let error_message = ""
    // 体験申込の流れがケース1（事前説明会を先に申し込む）の場合、日時は必ず入力させるようにする
    if(taiken_flow.value == 1){
        if((shakyo_list.value.flow_end_date == "" || shakyo_list.value.flow_end_date == null) || (shakyo_list.value.flow_end_time == "" || shakyo_list.value.flow_end_time == null)){
            error_message += "体験申込の流れを「ケース1」に設定する場合、「ホーム画面の初期表示変更日時」も必ず設定してください。"
        }
    }

    // 学生区分が全て利用不可の場合はエラー。0のままだと全て利用不可になっている
    console.log(gakusei_meisho_list.value)
    let gakusei_kbn_error = 0
    for(let g = 0;g < gakusei_kbn_list.value.length;g++){
        if(gakusei_kbn_list.value[g] == 1){
            gakusei_kbn_error = 1
        }
    }

    if(gakusei_kbn_error == 0){
        if(error_message != "") error_message += "\n"
        error_message += "学生区分は、どれか1つは必ず「〇」にしてください。"
    }

    if(error_message != ""){
        message.value = error_message;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "gakusei_eror";
        contentMessage.value = MessageModal
        return
    }


    message.value = "保存しますか？";

    // 現状がプログラム単位、かつ、以前が事業単位だった場合
    if(end_shubetsu.value == 2){
        if(end_shubetsu.value != shakyo_list.value.end_shubetsu){
            // 日時のどちらかが空の場合
            if((shakyo_list.value.end_date == "" || shakyo_list.value.end_date == null) || (shakyo_list.value.end_time == "" || shakyo_list.value.end_time == null)){
                message.value = "「受付〆切日の単位」を事業からプログラムに変更する場合は、\n必ず「受付終了日」を入力してください。\n※全てのプログラムの受付〆切日をこの日時で更新します。"
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "error";
                contentMessage.value = MessageModal
                return
            }else{
                message.value += "\n※「受付終了日の単位」が事業からプログラムに変更されているため、\n全ての体験プログラムの受付〆切日を「"+DateTimeSetting(shakyo_list.value.end_date+" "+shakyo_list.value.end_time)+"」に更新します。\n"

            }
        }
    }

    // 表示中のメール種別と更新前のメール種別が違う場合
    if(mail_shubetsu.value != shakyo_list.value.mail_shubetsu){
        message.value += "\n※「自動送信メールの実施」が変更されているため、メールの実施設定を一括変更します。"
    }
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "update";
    contentMessage.value = MessageModal
  }

  import { useStore } from 'vuex'
  const store = useStore()

  let search_param = {}
  let all_bunrui_list = []

  const render = ref(0);
  let loading_flg = ref(false)

  let Smart_search_open = ref(null)

  let cityname = route.params.shakyo
  /* その他の関数 */

    // 1項目でも編集されたらフラグを立てる
    let checkEdit = function(){
            contentLeft.value = null
        if(paramLeft.edit_update != 2){
            console.log(paramLeft.edit_update)
            paramLeft = {"edit_update":1}
        }
        contentLeft.value = ShakyoLeftbar
        displayLeft.value = false
        nextTick(() => {
            displayLeft.value = true
        })
    }
 
      
  // メッセージを表示するウィンドウでOKを押された時
  let OK_message = function(){ 
      Close_message();//メッセージを表示するウィンドウを閉じる

      switch(message_method.value) {
          case "checkin_non_kaisai":
          case "checkin_non_moushikomi":
          case "checkin_non_kensyu":
              // １：申込んではいるが開催日ではない
              // ２：申込んでいない
              // ３；前提となる事前説明会への参加が行われていない
              // 強制的にログイン後の初期画面を表示し、カメラも切断する
              router.push("/"+cityname+"/Kanri")
              break
          case "checkin_non_login":    
              logout()
              break
          case "update":
              // 保存しますか？→OK

              // 現状がプログラム単位、かつ、以前が事業単位だった場合は、先にプログラムの受付〆切日を変更する
              if(end_shubetsu.value == 2){
                if(end_shubetsu.value != shakyo_list.value.end_shubetsu){
                    Shimekiri_update()
                }else{
                    // 社協情報自身の更新
                    Send()
                }
              }else{
                // 社協情報自身の更新
                Send()
              }

              break
          case "update_kanryo":
              // 保存しました→OK
              location.reload()
              break
          case "user_setting_move":
                // ユーザー情報設定画面へ移動する
                router.push("/"+cityname+"/Kanri/User/disp/?home")
                break
          default:  
              break
      }        

  }

  // メッセージを表示するウィンドウを閉じる
  let Close_message = function(){
      contentMessage.value = null
      message_flag.value = false;
  }

    let send_error_count = 0
  // 更新する
  let Send = function() {
    
        if(shakyo_list.value.kokai_start == ""){
            shakyo_list.value.kokai_start = "00:00"
        }
        if(shakyo_list.value.moshikomi_start == ""){
            shakyo_list.value.moshikomi_start = "00:00"
        }
        if(shakyo_list.value.end_date == ""){
            shakyo_list.value.end_date = null
        }
        if(shakyo_list.value.end_time == ""){
            shakyo_list.value.end_time = "00:00"
        }
        if(shakyo_list.value.kokai_end_date == ""){
            shakyo_list.value.kokai_end_date = null
        }
        if(shakyo_list.value.kokai_end_time == ""){
            shakyo_list.value.kokai_end_time = "00:00"
        }
        if(shakyo_list.value.pc_age == "" || shakyo_list.value.pc_age == null){
            shakyo_list.value.pc_age = 18
        }

        // 事前説明会を実施しない場合は、体験フローは2で固定）
        if(shakyo_list.value.jizen_jisshi == 2){
            taiken_flow.value = 2
        }

        let before_message = ""
        if(shakyo_list.value.before_message){
            before_message = shakyo_list.value.before_message.replace(/<p><br><\/p>/g, '').trim()
        }

        let after_message = ""
        if(shakyo_list.value.after_message){
            after_message = shakyo_list.value.after_message.replace(/<p><br><\/p>/g, '').trim()
        }
        let account_message = ""
        if(shakyo_list.value.account_message){
            account_message = shakyo_list.value.account_message.replace(/<p><br><\/p>/g, '').trim()
        }
        let user_add_message = ""
        if(shakyo_list.value.user_add_message){
            user_add_message = shakyo_list.value.user_add_message.replace(/<p><br><\/p>/g, '').trim()
        }

      // APIのURLを指定する
      let Set_URL = url + "Shakyo_update"
      let Set_result = {
          shakyo_code:shakyo_list.value.shakyo_code,
          policy:shakyo_list.value.policy,
          policy_title:shakyo_list.value.policy_title,
          policy_footer:shakyo_list.value.policy_footer,
          kokai_date:shakyo_list.value.kokai_date,
          kokai_start:shakyo_list.value.kokai_start,
          moshikomi_date:shakyo_list.value.moshikomi_date,
          moshikomi_start:shakyo_list.value.moshikomi_start,
          houkoku_shubetsu:shakyo_list.value.houkoku_shubetsu,
          houkoku_kainyu:shakyo_list.value.houkoku_kainyu,
          shomeisho_shubetsu:shakyo_list.value.shomeisho_shubetsu,
          header_logo:shakyo_list.value.header_logo,
          header_title1:shakyo_list.value.header_title1,
          header_title2:shakyo_list.value.header_title2,
          header_title_color1:shakyo_list.value.header_title_color1,
          header_title_color2:shakyo_list.value.header_title_color2,
          flow:taiken_flow.value,// shakyo_list外の項目
          flow_end_date:shakyo_list.value.flow_end_date,
          flow_end_time:shakyo_list.value.flow_end_time,
          sanka:shakyo_list.value.sanka,
          end_shubetsu:end_shubetsu.value ,// shakyo_list外の項目
          end_date:shakyo_list.value.end_date,
          end_time:shakyo_list.value.end_time,
          shomeisho_count:shakyo_list.value.shomeisho_count,
          mail_shubetsu:mail_shubetsu.value, // shakyo_list外の項目
          enqete_shubetsu:enqete_shubetsu.value,// shakyo_list外の項目
          taiken_nissu:shakyo_list.value.taiken_nissu,
          program_count:shakyo_list.value.program_count,
          program_shubetsu:shakyo_list.value.program_shubetsu,
          cancel_count:shakyo_list.value.cancel_count,
          cancel_day:shakyo_list.value.cancel_day,
          cancel_setting:shakyo_list.value.cancel_setting,
          kokai_end_date:shakyo_list.value.kokai_end_date,
          kokai_end_time:shakyo_list.value.kokai_end_time,
          before_message:before_message,
          after_message:after_message,
          account_message:account_message,
          user_add_message:user_add_message,
          jizen_jisshi:shakyo_list.value.jizen_jisshi,
          jigo_jisshi:shakyo_list.value.jigo_jisshi,
          checkin_flg:shakyo_list.value.checkin_flg,
          checkin_disp_flg:shakyo_list.value.checkin_disp_flg,
          all_moshikomi_flg:shakyo_list.value.all_moshikomi_flg,
          all_moshikomi_count:shakyo_list.value.all_moshikomi_count,
          pc_age:shakyo_list.value.pc_age,
          gakusei_kbn_list:gakusei_kbn_list.value.toString(),// shakyo_list外の項目
          gakusei_meisho_list:gakusei_meisho_list.value.toString(),// shakyo_list外の項目
          update_user:GlobalData.$User_email
      }

      console.log(Set_result)

      // APIへ値を送信する
      axios.post(GlobalData.$API_URL+"Shakyo_update",
          Set_result)//ヘッダーを追加（IDトークンを送信）
          .then(response => {
              // 正常な結果が返ってきた場合の処理
              // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが削除できなかった等）。
              // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

              if(response.data["status"] == 1){

                message.value = "エラーが発生しました。\n"+response.data["message"];
                message_method.value = "add_error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
              }else{
                // 表示中のメール種別と更新前のメール種別が違う場合
                if((mail_shubetsu.value != shakyo_list.value.mail_shubetsu)){
                    Mail_all_update()
                }else if((taiken_flow.value != shakyo_list.value.flow) || (enqete_shubetsu.value != shakyo_list.value.enqete_shubetsu)){
                    // 体験フローまたはユーザー登録後アンケートが変更されていた場合のみ
                    Mail_other_update()
                }else{
                    message.value = "更新が完了しました。";
                    message_method.value = "update_kanryo";
                    message_cat.value = 0;
                    message_flag.value = true;
                    contentMessage.value = MessageModal
                }
              }
          })
          .catch(error => {
            if(send_error_count == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "send_error";
                contentMessage.value = MessageModal
            }else{
                send_error_count++
                setTimeout(function(){Send()},"1000")
            }
          })

  }

  let all_update_error = 0
  // 自動送信メールの実施設定が変更された場合の対応
  let Mail_all_update = function(){

    // メール情報を全て取得する
        let set_url = url + "Mail_get_list"
        axios.post(set_url,
        {
            choson_code:GlobalData.choson_code,
            kubun:0
        },
        GlobalData.$ID_Token)  //市区町村コードを指定
        .then(response => {
            let results = response.data.mail;

            for(let m = 0;m<results.length;m++){
                let set_mail = results[m]
                let jisshi = true
                if(mail_shubetsu.value == 2){
                    jisshi = false
                }

                // メールの種類が７（事前説明会申込時）
                if(set_mail.syurui == 7){
                    // 体験フローに変更があったとき
                    if(taiken_flow.value != shakyo_list.value.flow){
                        // 体験フロー１なら実施
                        if(taiken_flow.value == 1){
                            jisshi = true
                        }else{
                            jisshi = false
                        }
                    }
                }
                // メールの種類が８（アンケート提出時）
                if(set_mail.syurui == 8){
                    // ユーザー登録後アンケートに変更があったとき
                    if(enqete_shubetsu.value != shakyo_list.value.enqete_shubetsu){
                        // アンケート実施ならメールも実施
                        if(enqete_shubetsu.value == 1){
                            jisshi = true
                        }else{
                            jisshi = false
                        }
                    }
                }

                set_mail.jisshi = jisshi
                Mail_update(set_mail)

                if(m == (results.length-1)){
                    
                    message.value = "更新が完了しました。";
                    message_method.value = "update_kanryo";
                    message_cat.value = 0;
                    message_flag.value = true;
                    contentMessage.value = MessageModal
                }
            }

        })
        .catch(error => {
            if(all_update_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                all_update_error++
                setTimeout(function(){Mail_all_update()},"1000")
            }
        })

  }
  
  let other_update_error = 0
  // 体験フローかユーザー登録後アンケートによる変更があった場合
  let Mail_other_update = function(){

    // メール情報を全て取得する
    let set_url = url + "Mail_get_list"
    axios.post(set_url,
    {
        choson_code:GlobalData.choson_code,
        kubun:0
    },
    GlobalData.$ID_Token)  //市区町村コードを指定
    .then(response => {
        let results = response.data.mail;

        for(let m = 0;m<results.length;m++){
            let set_mail = results[m]

            // メールの種類が７（事前説明会申込時）
            if(set_mail.syurui == 7){
                // 体験フローに変更があったとき
                if(taiken_flow.value != shakyo_list.value.flow){
                    // 体験フロー１なら実施
                    console.log(taiken_flow.value)
                    if(taiken_flow.value == 1){
                        set_mail.jisshi = true
                        Mail_update(set_mail)
                    }
                }
            }
            // メールの種類が８（アンケート提出時）
            else if(set_mail.syurui == 8){
                // ユーザー登録後アンケートに変更があったとき
                if(enqete_shubetsu.value != shakyo_list.value.enqete_shubetsu){
                    // アンケート実施ならメールも実施
                    if(enqete_shubetsu.value == 1){
                        set_mail.jisshi = true
                    }else{
                        set_mail.jisshi = false
                    }
                    
                    Mail_update(set_mail)
                }
                    
            }

            if(m+1 == results.length){
                message.value = "更新が完了しました。";
                message_method.value = "update_kanryo";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
            }
        }
        
        
    })
    .catch(error => {
        if(other_update_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            other_update_error++
            setTimeout(function(){Mail_other_update()},"1000")
        }
    })

}

let kobetsu_update_error = 0

  // メール情報を更新
  let Mail_update = function(mail){
    console.log(mail)
    let set_url = url + "Mail_update"
        axios.post(set_url,
        {
            mail_id:mail.mail_id,
            jisshi:mail.jisshi,
        },
        GlobalData.$ID_Token)  //市区町村コードを指定
        .then(response => {
            if(response.data["status"] == 1){

                message.value = "メール実施設定の更新でエラーが発生しました。\n"+response.data["message"];
                message_method.value = "add_error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
            }

        })
        .catch(error => {
                
            if(kobetsu_update_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                other_update_error++
                setTimeout(function(){Mail_update(mail)},"1000")
            }
        })
  }

let shimekiri_error = 0
let Shimekiri_update = function() {
    
      // APIのURLを指定する
      let Set_URL = url + "Taiken_update_shimekiri"
      let Set_result = {
          choson_code:GlobalData.choson_code,
          shimekiri_day:shakyo_list.value.end_date,
          shimekiri_time:shakyo_list.value.end_time,
      }

      // APIへ値を送信する
      axios.post(Set_URL,
          Set_result,
          GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
          .then(response => {
              //正常な結果が返ってきた場合の処理
              // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが削除できなかった等）。
              // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

              if(response.data["status"] == 1){

                message.value = "エラーが発生しました。\n"+response.data["message"];
                message_method.value = "add_error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
              }else{
                 // 社協情報自身の更新へ
                Send()
              }
          })
          .catch(error => {
            if(shimekiri_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "send_error";
                contentMessage.value = MessageModal
            }else{
                shimekiri_error++
                setTimeout(function(){Shimekiri_update()},"1000")
            }
          })

  }

// 「ファイルを選択」ボタン押下
let addimg = function(){
  const file_set = document.getElementById("img_file")
  file_set.click()
}

let error_count  = 0
// 画像ファイル取得
// 画像ファイル取得 & Lambda へ送信
const imgUpload = async (e) => {

    // エラー初期化
    error_count = 0;

    const fileInput = e.target;
    const file = fileInput.files[0];
    if (!file) return;

    // 拡張子取得
    const accept = file.name.split(".").pop();

    // ファイル名作成
    const today = new Date();
    const fileNameOnly =
        `${GlobalData.shakyo}_${today.getFullYear()}${today.getMonth()+1}${today.getDate()}` +
        `${today.getHours()}${today.getMinutes()}${today.getSeconds()}`;

    // アップロード先のフォルダを指定
    const folder = 'header/img'
    const file_name = `${folder}/${fileNameOnly}.${accept}`;

    console.log(file_name)

    // Lambda に送る payload
    const formData = new FormData();
    formData.append("file_name", file_name);
    formData.append("file", file);
    formData.append("Bucket",GlobalData.$Image_bucket)

    try {
        // Lambda API Gateway の URL。APIGatewayではなくLambdaの関数URLを利用
        const set_url = GlobalData.$fileupload_url;

        // 呼び出し
        const response = await axios.post(set_url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        console.log("Lambda response:", response.data);
//        getImage(response.data.fileUrl)
        
        // 画像のURLを指定して再読み込み
         shakyo_list.value.header_logo = "https://"+GlobalData.$Image_bucket+".s3-ap-northeast-1.amazonaws.com/"+file_name
         //if01.value.contentWindow.addimg(response.data.fileUrl)
       // finish()

       // 編集フラグを立てる
        checkEdit()
    } catch (error) {
        console.error("Upload error:", error);
        error_count++;
    }
};

/*
const imgUpload = (e) => {
    error_count  = 0
  const fileInput = e.target;
  const file = fileInput.files[0];

  let accept = file.name.split(".")[1]
  let file_name = GlobalData.shakyo+"_"+file.name.split(".")[0]+"."+accept
  upload(file, file_name, GlobalData.$ID_Token);
}

// ファイルアップロード
function upload (uploadedFile, filename, idtoken) {
    // PROVEDER_KEY作成
    let PROVIDER_KEY = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;
    AWS.config.region = 'ap-northeast-1';
    // IDプールにてIDトークンの認証を行う
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: GlobalData.$IdentityPoolId,
        Logins: {
            [PROVIDER_KEY]: idtoken.headers.Authorization,
        }
    });
    
        //資格情報のリフレッシュ処理
        AWS.config.credentials.refresh((err) => {
            if(err) {
                if(error_count == 5){
                    alert("画像ファイルのアップロードに失敗しました。" + err);
                }else{
                    error_count++
                    setTimeout(function(){upload(uploadedFile, filename, idtoken)},"1000")
                }
            }
        });
    
    // S3オブジェクト作成
    var s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: 'ap-northeast-1'
    });

    // パラメータ作成
    const params = {
      Bucket: GlobalData.$Image_bucket,
      Key: 'header/img/'+filename,
    }
    params.Body=uploadedFile;

    return new Promise((resolve, reject) => {
      // S3へオブジェクトをアップロード
      s3.putObject(params, (err, data) => {
        if (err) {
            if(error_count == 5){
                reject(err)
                alert("画像ファイルのアップロードに失敗しました。"+err)
            }else{
                error_count++
                setTimeout(function(){upload(uploadedFile, filename, idtoken)},"1000")
            }
        } else {
          resolve(data)
          shakyo_list.value.header_logo = "https://"+GlobalData.$Image_bucket+".s3-ap-northeast-1.amazonaws.com/header/img/"+filename
          //getImage(filename)

        }
      })
    })
}
*/
//---------------- スマホ画面表示
const smart_dsp = () => {
    param = { checkin_flg:checkin_flg }
    content.value = ShakyoSmartMenu
}

// ページの一番上にスクロールする：height＝位置（上から何pxか）
const Page_scroll = async (height) => {
  await nextTick()               // Vue の DOM 更新を待つ
  await new Promise(r => setTimeout(r, 0)) // ブラウザのレイアウト確定を待つ

  requestAnimationFrame(() => { // レイアウトが最終確定した次のタイミング
    // スマホ・PCのどちらか、横幅でチェック
    const isSP = window.matchMedia("(max-width: 960px)").matches;
        
    if (isSP) {
      // スマホ
      window.scrollTo({
          top: height,
          left: 0,
          behavior: "auto",
      });
    } else {
      // PC
      const el = document.querySelector("#vy_main")
          
      if (el) {
        el.scrollTo({ top: height, behavior: "auto" })
      }
    }
  })
}

// チェックイン前に事前説明会の実績を確認
let jizen_jisseki_check_error = 0
const Jizen_jisseki_check = (jizenkensyu_no,id,u_id) =>{
     // ユーザーID・区分・プログラムIDを指定する
     axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:u_id, program_kbn:2}, GlobalData.$ID_Token)
    .then(response => {
        let jisseki_jizen = response.data.jisseki  // 自分の実績レコード（事前説明会）を取得する
        let jizen_ok = 0

        let no_array = jizenkensyu_no.split(",")
        // 0 件の場合は参加できず
        // 1件以上あっても、チェックインしてなければ参加できず
        if(jisseki_jizen.length != 0){
            // プログラムに格納された事前説明会のNo.を確認
            
            for(let n = 0;n<no_array.length;n++){
                // 事前説明会の実績を確認
                for(let j = 0 ;j<jisseki_jizen.length;j++){
                    
                    if(jisseki_jizen[j].syurui == 4 || jisseki_jizen[j].syurui == 5){
                        // 申込済みの事前説明会が「特殊（対面・オンライン）」の場合は問答無用で参加可能とする
                        if(jisseki_jizen[j].jokyo == '2'){
                          jizen_ok = 1
                        }
                    }else
                    // 事前説明会実績のNo.がプログラムに格納されたNo.と合致する場合
                    if(no_array[n] == jisseki_jizen[j].jizen_no){
                        // その実績が参加済であればOK
                        if(jisseki_jizen[j].sanka_flg == 1 ){
                            // 申込済みの事前説明会が任意参加の場合は、説明会参加の有無にかかわらず体験プログラムもOKとする
                            jizen_ok = 1
                        }else
                        // 申込済みの事前説明会が必須参加の場合は、その実績が参加済であればOK
                        if(jisseki_jizen[j].jokyo == '2'){
                            jizen_ok = 1
                        }
                    }
                }
            }
        }
        if(jizen_ok == 0){
            loading_flg.value = false
            message.value = "事前説明会へ参加していないため、プログラムへのチェックインができません。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_kensyu";
            contentMessage.value = MessageModal
        }else{
            checkin(id,u_id,1);
        }
    })
    .catch(error => {
        if(jizen_jisseki_check_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            jizen_jisseki_check_error++
            setTimeout(function(){Jizen_jisseki_check(jizenkensyu_no,id)},"1000")
            
        }
    })
}

//-------------------- チェックイン状態の確認
// kensyu_dateは事前説明会の場合のみ利用
let checkin_error = 0
const checkin = (program_id,user_id,kbn,kensyu_date) => {

    let program_name = "事前説明会"
    if(kbn == 1){
        program_name = "体験プログラム"
    }else if(kbn == 3){
        program_name = "事後集会"
    }
    
    // ユーザーID・区分・プログラムIDを指定する
    axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:user_id, program_kbn:kbn, program_id:program_id}, GlobalData.$ID_Token)
    .then(response => {
        loading_flg.value = false
        // ソーシャルログイン時に利用する戻る社協英名、画面、IDを削除
        localStorage.removeItem('return_shakyo')
        localStorage.removeItem('checkin')
        localStorage.removeItem('checkin_id')
        
        let jisseki_all = []
        jisseki_all[0] = response.data.jisseki

        // 今日の日付（参加日と比較用）
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()
        console.log("today:"+set_date)

        if(jisseki_all.length == 0){
            
            message.value = "この"+program_name+"には申込んでいません。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_moushikomi";
            contentMessage.value = MessageModal
        }else{

            let set_jisseki = null

            console.log("実績："+JSON.stringify(jisseki_all))

            for(let i = 0;i<jisseki_all.length;i++){
                for(let i2 = 0;i2 < jisseki_all[i].length;i2++){
                    let check_jisseki = jisseki_all[i][i2]
                    
                    if(check_jisseki.jokyo != 9){

                        // 実績に紐づくものが体験プログラムで、プログラムの種別が「2：制作・寄付」だったらそのままチェックイン済みとする
                        if(check_jisseki.shubetsu == 2 && kbn == 1){
                            set_jisseki = check_jisseki
                        }else if(kbn == 2 && (!kensyu_date || kensyu_date == '')){
                            // 実績に紐づくものが事前説明会で、説明会の開催日が未入力だったら、事前説明会のIDを持つ実績を格納する
                            if(check_jisseki.program_id == program_id){
                                set_jisseki = check_jisseki
                            }
                        }else{
                            let kaisai_set = Kaisai_setting(check_jisseki["kaisai_date"])
                            console.log("today_set:"+today_set +"/kaisai_set:"+ kaisai_set)
                            // 今日と同じ日付が存在する場合
                            if(today_set ==  kaisai_set){
                                set_jisseki = check_jisseki
                            }
                        }

                    }
                }
            }

            if(set_jisseki == null){
                
                message.value = "本日はこの"+program_name+"の参加日ではありません。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "checkin_non_kaisai";
                contentMessage.value = MessageModal

            }else{
                // チェックイン済みならその旨を表示
                if(set_jisseki.jokyo > "1"){

                    let set_message = "本日はチェックイン済みです。"
                    if(set_jisseki.shubetsu == 2){
                        set_message = "このプログラムは提出済みです。"
                    }
                    param = {check_jisseki:set_jisseki,message:set_message,checkin_date:set_jisseki["checkin_date"],cityname:cityname,rt:'kanri' }
                    content.value = UserCheckin
                }else{
                    // 参加前ならチェックイン処理へ
                    set_checkin(set_jisseki,set_jisseki.program_id,kbn,set_date,program_id,user_id)
                }
            }
        }

    })
    .catch(error => {
        if(checkin_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            checkin_error++
            setTimeout(checkin(program_id,user_id,kbn,kensyu_date),"1000")
            
        }
    })
}

//-------------------- チェックイン処理
let set_checkin_error = 0
const set_checkin = (set_jisseki,program_id,kbn,sanka_date,main_taiken_id,user_id) => {
    
    sanka_date.setHours(sanka_date.getHours()+9);
    let set_array = {user_id:user_id, program_kbn:kbn, program_id:program_id}
    // 実績に紐づくものが体験プログラムで、プログラムの種別が「1：施設・地域」だったら参加日を入力する
    if(set_jisseki.shubetsu == 1 && kbn == 1){
        set_array = {user_id:user_id, program_kbn:kbn, program_id:program_id, kaisai_date:sanka_date}
    }
    // 特殊説明会のフラグが立っていたらフラグも入れて送る
    if(set_jisseki.tokusyu){
        set_array.tokusyu = set_jisseki.tokusyu
    }
    
    axios.post(url+"Jisseki_CheckIn-Out",set_array, GlobalData.$ID_Token)
    .then(response => {
        // ソーシャルログイン時に利用する戻る社協英名、画面、IDを削除
        localStorage.removeItem('return_shakyo')
        localStorage.removeItem('checkin')
        localStorage.removeItem('checkin_id')

        
        // 履歴登録
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        rireki_kanri_add(set_date,3,user_id,kbn,main_taiken_id,0)

        // 今日の日付（参加日と比較用）
        let disp_date = new Date(today);
        disp_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        disp_date = new Date(disp_date);

            
        param = {check_jisseki:set_jisseki,message:"チェックインしました。",checkin_date:disp_date,cityname:cityname,rt:"Kanri" }
        content.value = UserCheckin

    })
    .catch(error => {
//        alert("チェックイン時にエラーが発生しました。"+error)
        if(set_checkin_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            set_checkin_error++
            setTimeout(function(){
                    
                param = { cmd:route.params.cmd, id:route.params.id }
                call(param)
            },"1000")
        }
    })

}

//---------------- 履歴を登録する
let rireki_add_error = 0
let rireki_kanri_add = function(toroku_date,kubun,taikenuser_id,program_kbn,program_id,mail_rireki_id){
    let set_choson_code = ""
/*
    if(choson_code != ""){
        set_choson_code = choson_code
    }
*/
    set_choson_code = GlobalData.choson_code
    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:set_choson_code,
        taikenuser_id:taikenuser_id,
        program_kbn:program_kbn,
        program_id:program_id,
        mail_rireki_id:mail_rireki_id,
        kubun:kubun,
        toroku_date:toroku_date,
        update_user:GlobalData.$User_email}

    // APIへ値を送信する
    axios.post(url+"Rireki_add",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
            
    })
    .catch(error => {
        if(rireki_add_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "rireki_update_error";
            contentMessage.value = MessageModal
        }else{
            rireki_add_error++
            setTimeout(function(){
                rireki_kanri_add(toroku_date,kubun,taikenuser_id,program_kbn,program_id,mail_rireki_id)
            },"1000")
        }
    })
}

let color_change1 = function(){
    title_style1.value["color"] = shakyo_list.value.header_title_color1
    checkEdit()
}

let color_change2 = function(){
    title_style2.value["color"] = shakyo_list.value.header_title_color2
    checkEdit()
}

let gakusei_kbn_change = function(num){
    if(gakusei_kbn_list.value[num] == '0'){
        gakusei_kbn_list.value[num] = '1'
    }else{
        gakusei_kbn_list.value[num] = '0'
    }
    // 編集フラグを立てる
    checkEdit()
}


// ユーザー情報設定画面へ遷移
let user_setting_move = function(){

    message.value = "ユーザー情報設定画面に移動しますか？<br>※編集内容は保存されません。";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "user_setting_move";
    contentMessage.value = MessageModal
}

  // HOME画面へ戻る
  let Return_home = function(){
      router.push('/'+GlobalData.shakyo+'/Kanri')
  } 
  
let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/HOME-173c0be34f8f8074bc1afa1725b3867d"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")

}

// login_checkで取得するGlobalData.$User_emailの値が設定される迄待つ
setTimeout(function(){Shakyouser_read()},"1000")

  
  //-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
  const wt = watch(route, () => {
      param = { cmd:route.params.cmd, id:route.params.id }
      call(param)
  })

// スマホ画面の判定 　
const isMobile = ref(false)
let mq

const onChange = (e) => {
    isMobile.value = e.matches
  
    // 途中でスマホにした場合
    if(isMobile.value == true){
        smart_dsp()
    }
}

onMounted(() => {
    mq = window.matchMedia('(max-width: 960px)')

    // 初期判定
    isMobile.value = mq.matches

    // ログイン画面からスマホの場合
    if(isMobile.value == true){
        login_check()
        setTimeout(function(){smart_dsp()},"1500")
    }

    // 変更監視
    mq.addEventListener('change', onChange)

    
})

onMounted(async () => {
  await nextTick()
  setTimeout(function(){paramLeft = {"edit_update":0}}, "1000");
    
})


onUnmounted(() => {
    mq.removeEventListener('change', onChange)
})

  //-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
  const call = function(proc) {
  
      switch(proc.cmd) {
          case "page_scroll"://----------ページトップまでスクロール
              Page_scroll(0)
              break
          case "Readcode":   //-------------- 二次元コードを読み込む画面を表示
              title = "二次元コード読取"
              param = {rt:'kanri'}
              content.value = ShakyoMyCode
              render.value++ 
              // contentLeft.value = Leftbar
              break 
          case "loading_start":
              // ローディングアイコン表示
              loading_flg.value = true
              break
          case "loading_end_noreload":
              // ローディングアイコン解除
              loading_flg.value = false
              break
          case "checktaiken":  //-------------- チェックイン（体験）
              login_check()
         
              axios.post(url+"Taiken_read", {taiken_id:proc.t_id})
              .then(response => {
                  let taiken_jizen_no = response.data.jizenkensyu_no

                  if(taiken_jizen_no != [] && taiken_jizen_no != "" && taiken_jizen_no != null){
                      Jizen_jisseki_check(taiken_jizen_no,proc.t_id,proc.tu_id)
                  }else{
                      checkin(proc.t_id,proc.tu_id,1)
                  }
              })
              .catch(error => {
                  console.log("体験チェックイン Taiken_readエラー:",error)
              })
              break
          case "checkjizen":  //-------------- チェックイン（事前説明会）

              login_check()
              // チェックイン前に事前説明会の種類を取得
              axios.post(url+"Jizen_read", {jizen_id:proc.t_id})
              .then(response => {

                  let syurui = response.data.syurui
                  // 動画視聴期間は種類3（動画視聴）のみ利用する。未入力であれば日付を問わずチェックインOK
                  let kensyu_date = response.data.kensyu_date // 開催日または動画視聴期間（至）

                  if(syurui == '4' || syurui == '5'){
                      // チェックイン処理へ
                    
                      // 今日の日付（参加日）
                      const today = new Date()
                      let set_date = new Date(today);
                      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                      set_date = new Date(set_date);

                      let set_jisseki = {"program_kbn":2,"shubetsu":2,"kbn":1,"jizen_name":response.data.jizen_name,'tokusyu':'on'}
                    
                      setTimeout(function(){

                        // 自分の市区町村コードと説明会の市区町村コードが違う場合
                        if(choson_code != response.data.choson_code){
                            loading_flg.value = false
                            message.value = "所属社協が違うため、この特殊説明会は受けられません。";
                            message_cat.value = 0;
                            message_flag.value = true;
                            message_method.value = "checkin_non_kensyu";
                            contentMessage.value = MessageModal
                        }else{
                            set_checkin(set_jisseki,proc.t_id,2,set_date)
                        }
                      },"1000")
                    
                  }else{
                      checkin(proc.t_id,proc.tu_id,2,kensyu_date)
                  }
              })
              .catch(error => {
                  console.log("事前説明会 Jizen_readエラー:",error)
              })
              break
          case "checkjigo":  //-------------- チェックイン（事後集会）
              login_check()
         
              checkin(proc.t_id,proc.tu_id,3)
              break
          case 'open_taikensha':
              // 子コンポーネント側（ShakyoRightBar）からの命令でウィンドウを開く
              
                message_cat.value = 2;
                message_flag.value = true;
                contentMessage.value = MessageModal
              break
          case 'update':
              // 子コンポーネント側（ShakyoHomeLeftBar）からの命令で保存処理を行う
              Update_check()
              break
          default:
              break
      }
  }

onMounted(() => {

  // quillのツールバーのアイコンにマウスホバー時の文言を日本語にしている  

  const map = {
    'ql-bold': '太字',
    'ql-italic': '斜体',
    'ql-underline': '下線',
    'ql-strike': '打ち消し線',
    'ql-list': '箇条書き',
    'ql-link': 'ハイパーリンク',
    'ql-clean': '書式クリア'
  }

  Object.entries(map).forEach(([cls, label]) => {
    document.querySelectorAll(`.${cls}`).forEach(el => {
      el.setAttribute('data-label', label)
    })
  })

  document.querySelectorAll('.ql-toolbar').forEach((toolbar) => {
    // picker（ここが重要） querySelectorは、展開されたhtmlのclass上位(ql-formats)からql-picker-labelまで追いかけて直接タイトルを設定している
    toolbar.querySelector('.ql-formats .ql-color .ql-picker-label').setAttribute('title', '文字色');
    toolbar.querySelector('.ql-formats .ql-background .ql-picker-label').setAttribute('title', '背景色');
    toolbar.querySelector('.ql-formats .ql-size .ql-picker-label').setAttribute('title', '文字サイズ');

  });


})

</script>


<style scoped>
    table.vy-form-table th {
        width:35%
    }

    #gakusei_kbn_table tr td{
        border: 1px solid #000;
        text-align: center;
    }

    #gakusei_kbn_table tr:nth-child(1) td{
        border-bottom: 2px solid #000;
    }
    /* 共通 */
:deep(.ql-toolbar button) {
  position: relative;
}

/* hover 時に表示 */
:deep(.ql-toolbar button:hover::after) {
  content: attr(data-label);
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 100;
}
/* hover 時に表示 */
:deep(.ql-toolbar .ql-picker-label:hover::after) {
  content: attr(title);
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 100;
}

/* quillのツールボックスのサイズの表示名を日本語に */
/* ▼ size ドロップダウンの表示文字（選択後のラベルも含む） */
:deep(.ql-snow .ql-picker.ql-size .ql-picker-label::before),
:deep(.ql-snow .ql-picker.ql-size .ql-picker-item::before) {
  content: "標準";
}

/* small/large/huge を日本語化 */
:deep(.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before),
:deep(.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before) { content: "小"; }

:deep(.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before),
:deep(.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before) { content: "大"; }

:deep(.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before),
:deep(.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before)  { content: "特大"; }

/* ハイパーリンク関係を日本語化、かつ、一部テキストは削除 */
:deep(.ql-snow .ql-tooltip[data-mode="link"]::before) {
  content: "URLを入力:";
}

:deep(.ql-snow .ql-tooltip[data-mode="link"] .ql-action::after) {
  content: "保存";
}

:deep(.ql-snow .ql-tooltip[data-mode="link"] .ql-remove::before) {
  content: "削除";
}
:deep(.ql-snow .ql-tooltip[data-mode="link"]::before) {
  content: "";
}

:deep(.ql-tooltip::before){
  content: "";
}

:deep(.ql-tooltip a.ql-action::after ){
  content: "URL編集";
}

:deep(.ql-tooltip a.ql-remove::before ){
  content: "削除";
}
</style>